import { render, staticRenderFns } from "./CardMinimal.vue?vue&type=template&id=72bc3786"
import script from "./CardMinimal.vue?vue&type=script&lang=js"
export * from "./CardMinimal.vue?vue&type=script&lang=js"
import style0 from "./CardMinimal.vue?vue&type=style&index=0&id=72bc3786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports